import "./Navbar.css";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { endSessionNow } from "../../../common/security/session";
import { db } from "../../../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const MODULE_PATH = "/kisiye-ozel-rapor";

const Navbar = () => {
  const { user, role, logout, userPermissions, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [fallbackMap, setFallbackMap] = useState(null);
  const [fetchingPerm, setFetchingPerm] = useState(false);

  const mapInCtx = userPermissions?.["kisiye-ozel-rapor"];

  const hasAnyTrue = (map) =>
    map && typeof map === "object" && Object.values(map).some((v) => v === true);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".navbar")) setMenuOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  useEffect(() => {
    if (loading || !user) return;
    if (hasAnyTrue(mapInCtx)) {
      setFallbackMap(null);
      return;
    }

    (async () => {
      try {
        setFetchingPerm(true);
        let snap = null;
        if (user.email) snap = await getDoc(doc(db, "users", user.email));
        if (!snap || !snap.exists()) snap = await getDoc(doc(db, "users", user.uid));
        const data = snap?.exists() ? (snap.data() || {}) : {};
        setFallbackMap(data["kisiye-ozel-rapor"] || {});
      } finally {
        setFetchingPerm(false);
      }
    })();
  }, [loading, user, mapInCtx]);

  const effectiveMap = hasAnyTrue(mapInCtx) ? (mapInCtx || {}) : (fallbackMap || {});
  
  // YETKİ KONTROLLERİ
  const canAylikIsg = effectiveMap["aylik-isg"] === true;
  const canPatron = effectiveMap["patron"] === true;
  const canHakedisTanim = effectiveMap["hakedis-tanimlari"] === true;
  const canHakedisHesap = effectiveMap["hakedis-hesaplama"] === true;
  
  const isOwner = role?.toLocaleLowerCase("tr-TR") === "oluşturucu";

  const showTanimlari = canHakedisTanim || isOwner;
  const showHesaplama = canHakedisHesap || isOwner;

  const handleLogout = async () => {
    try {
      await endSessionNow();
      await logout();
      navigate("/");
    } catch {
      navigate("/");
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Kişiye Özel Raporlar</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </div>

          <div className={`navbar-links ${menuOpen ? "show" : ""}`}>
            {(canAylikIsg || fetchingPerm) && (
              <NavLink className="navbar-link" to={`${MODULE_PATH}/aylik-isg`}>Aylık İSG</NavLink>
            )}

            {(canAylikIsg || fetchingPerm) && (
              <NavLink className="navbar-link" to={`${MODULE_PATH}/firestore-console`}>Konsol</NavLink>
            )}

            {/* Şartlı Linkler */}
            {(showTanimlari || fetchingPerm) && (
              <NavLink className="navbar-link" to={`${MODULE_PATH}/hakedis-tanimlari`}>Hakediş Tanımları</NavLink>
            )}

            {(showHesaplama || fetchingPerm) && (
              <NavLink className="navbar-link" to={`${MODULE_PATH}/hakedis-hesaplama`}>Hakediş Hesapla</NavLink>
            )}

            {(canPatron || fetchingPerm) && (
              <NavLink className="navbar-link" to={`${MODULE_PATH}/patron`}>Patron</NavLink>
            )}

            <NavLink className="navbar-link" to="/secilen-proje">🔁 Proje Seç</NavLink>
            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
